import type { Scenario } from "../entities";

export const SLEEP_SCENARIO_ID = "9e8d7c6b-5a4f-4e3d-8c2b-1a0f9e8d7c02";

export const sleepScenario: Scenario = {
  id: SLEEP_SCENARIO_ID,
  slug: "sleep",
  version: 1,
  builtIn: true,
  name: { en: "Sleep", ru: "Сон", de: "Schlaf", fr: "Sommeil", es: "Sueño", tr: "Uyku", hi: "नींद", sr: "Сан" },
  description: {
    en: "When you went to bed, when you got up and how you slept.",
    ru: "Когда легли, когда встали и как спалось.",
    de: "Wann Sie ins Bett gingen, wann Sie aufstanden und wie Sie geschlafen haben.",
    fr: "À quelle heure vous vous êtes couché, levé, et comment vous avez dormi.",
    es: "Cuándo te acostaste, cuándo te levantaste y qué tal dormiste.",
    tr: "Ne zaman yattığınız, ne zaman kalktığınız ve nasıl uyuduğunuz.",
    hi: "कब सोए, कब उठे और नींद कैसी रही।",
    sr: "Када сте легли, када сте устали и како сте спавали.",
  },
  calendarMarker: { questionId: "quality" },
  questions: [
    {
      id: "bedTime", type: "time",
      text: {
        en: "When did you go to bed?", ru: "Когда легли спать?", de: "Wann sind Sie ins Bett gegangen?", fr: "À quelle heure vous êtes-vous couché ?",
        es: "¿A qué hora te acostaste?", tr: "Ne zaman yattınız?", hi: "आप कब सोने गए?", sr: "Када сте легли?",
      },
    },
    {
      id: "wakeTime", type: "time",
      text: {
        en: "When did you wake up?", ru: "Когда проснулись?", de: "Wann sind Sie aufgewacht?", fr: "À quelle heure vous êtes-vous réveillé ?",
        es: "¿A qué hora te despertaste?", tr: "Ne zaman uyandınız?", hi: "आप कब उठे?", sr: "Када сте се пробудили?",
      },
    },
    {
      id: "quality", type: "scale", min: 1, max: 5,
      text: {
        en: "How did you sleep?", ru: "Как спалось?", de: "Wie haben Sie geschlafen?", fr: "Comment avez-vous dormi ?",
        es: "¿Qué tal dormiste?", tr: "Nasıl uyudunuz?", hi: "नींद कैसी रही?", sr: "Како сте спавали?",
      },
      labels: {
        min: { en: "badly", ru: "плохо", de: "schlecht", fr: "mal", es: "mal", tr: "kötü", hi: "खराब", sr: "лоше" },
        max: { en: "great", ru: "отлично", de: "hervorragend", fr: "très bien", es: "genial", tr: "harika", hi: "बहुत अच्छी", sr: "одлично" },
      },
    },
    {
      id: "note", type: "text", required: false,
      text: {
        en: "Anything else?", ru: "Хотите что-то добавить?", de: "Möchten Sie noch etwas hinzufügen?", fr: "Autre chose à ajouter ?",
        es: "¿Algo más que añadir?", tr: "Eklemek istediğiniz bir şey var mı?", hi: "कुछ और जोड़ना चाहेंगे?", sr: "Желите ли још нешто да додате?",
      },
    },
  ],
};
